import React from 'react';
import { motion } from 'framer-motion';
export function Includes() {
  return <section className="includes" data-id="element-86">
      <motion.div className="container" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-40px'
    }} transition={{
      duration: 0.8
    }} data-id="element-87">
        <span className="section-tag" data-id="element-88">Lo Que Recibes</span>
        <h2 data-id="element-89">Todo lo que incluye por $37</h2>

        <div className="includes-stack" data-id="element-90">
          <div className="include-card" data-id="element-91">
            <div className="include-num" data-id="element-92">01</div>
            <div data-id="element-93">
              <h3 data-id="element-94">Workshop completo grabado</h3>
              <p data-id="element-95">
                Ve a tu ritmo, pausa, repite. Te guío paso a paso desde cero
                hasta tener tu página publicada en internet. Acceso de por vida.
              </p>
            </div>
          </div>
          <div className="include-card" data-id="element-96">
            <div className="include-num" data-id="element-97">02</div>
            <div data-id="element-98">
              <h3 data-id="element-99">Template de página web profesional</h3>
              <p data-id="element-100">
                No empieza de cero. Te doy una estructura lista que solo tienes
                que personalizar con la información de tu negocio.
              </p>
            </div>
          </div>
          <div className="include-card" data-id="element-101">
            <div className="include-num" data-id="element-102">03</div>
            <div data-id="element-103">
              <h3 data-id="element-104">Fórmula de copy para cada sección</h3>
              <p data-id="element-105">
                Qué escribir en cada parte de tu página para que la gente lea,
                confíe y te contacte. Las 5 secciones que toda página que
                convierte necesita.
              </p>
            </div>
          </div>
          <div className="include-card" data-id="element-106">
            <div className="include-num" data-id="element-107">04</div>
            <div data-id="element-108">
              <h3 data-id="element-109">Los prompts exactos para la IA</h3>
              <p data-id="element-110">
                Las instrucciones que le das a la inteligencia artificial para
                que te entregue un diseño que parece hecho por un equipo de
                $5,000.
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}